// extracted by mini-css-extract-plugin
export default {"mainCarousel":"AvatarMain_mainCarousel__caOpk"};